export default __webpack_public_path__ + "static/media/104-mark.2fb7c7b8.svg";